import React, { useState } from "react";
import Sidebar from "../../components/SideBar";
import Header from "../../components/Header";
import AccessoryTab from "../ProductManagement/components/AccessoryTab";

const AccessoryManagement = () => {
  const [activePage, setActivePage] = useState("Accessories");
  const [productId, setProductId] = useState("");

  const handleNavigate = (page) => setActivePage(page);

  return (
    <div className="flex min-h-screen bg-[#F8F4F4]">
      <div className="max-sm:hidden flex">
        <Sidebar active={activePage} onNavigate={handleNavigate} />
      </div>
      <div className="flex-1 py-6 px-8 max-h-screen min-h-screen overflow-scroll">
        <Header hideSearch={false} />

        <div className="bg-white p-6 rounded shadow">
          <h2 className="text-2xl font-semibold mb-4">Accessory Management</h2>

          <div className="mb-4">
            <label className="block text-sm text-gray-700 mb-1">Product ID (manage accessories for a product)</label>
            <input
              value={productId}
              onChange={(e) => setProductId(e.target.value)}
              placeholder="Enter product id"
              className="w-full px-3 py-2 border rounded"
            />
          </div>

          {productId ? (
            <AccessoryTab productId={productId} />
          ) : (
            <div className="text-sm text-gray-600">Enter a product id to manage its accessories.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccessoryManagement;
